import request from '@/utils/request'

export function getDownloadLimit () {
  return request({
    url: '/admin/download/limit',
    method: 'get'
  })
}

export function putDownloadLimit (params) {
  return request({
    url: '/admin/download/limit',
    method: 'post',
    params
  })
}

export function getStatsDownload () {
  return request({
    url: '/admin/stats/download',
    method: 'get'
  })
}

export function getStatsVisit () {
  return request({
    url: '/admin/stats/visit',
    method: 'get'
  })
}

export function getStatsTeacher () {
  return request({
    url: '/admin/stats/teacher',
    method: 'get'
  })
}

export function loadTeachers (params) {
  return request({
    url: '/admin/teachers',
    method: 'post',
    data: params
  })
}

export function setAdmin (params) {
  return request({
    url: '/admin/setAdmin',
    method: 'post',
    data: params
  })
}

export function findTeachersByName (params) {
  return request({
    url: '/admin/teachers/name',
    method: 'post',
    data: params
  })
}

export function getYears () {
  return request({
    url: '/admin/years',
    method: 'get'
  })
}

export function getProvinces () {
  return request({
    url: '/admin/provinces',
    method: 'get'
  })
}

export function getCities (params) {
  return request({
    url: '/admin/cities',
    method: 'get',
    params
  })
}

export function importEntry (params) {
  return request({
    url: '/admin/dataset/import',
    method: 'post',
    data: params
  })
}

export function getRegionName (provinceCode, cityCode) {
  return request({
    url: `/admin/region/${provinceCode}/${cityCode}`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/admin.js